import { getEnvVar } from '@/shared/utils/envVarConfig';

export function getStreamApiKey() {
  const apiKey = getEnvVar('VITE_STREAM_API_KEY');
  if (!apiKey) {
    throw new Error('Stream API Key is not set in environment variables');
  }
  return apiKey;
}
